import { createTheme } from '@mantine/core'

export default createTheme({
  /** Put your mantine theme override here */
})
